import { ModalBodyWrapper, ModalWrapper, Card, SmallContentContainer } from '@mews-commander/ui';
import { IconName } from '@optimus-web/core';
import { ActionType, TextKey } from '@mews-commander/enums';
import { LocalizedText, useUUID } from '@mews/framework';
import { WithGuideLink } from '@mews-commander/types';
import { useCurrentEnterpriseId } from '@mews-commander/core';
import { useCloseButton } from '../../core';
import ModalHeader from '../../legacy/React/Components/Common/ModalHeader';
import { HeadingAction } from '../../legacy/React/Components/HeadingAction/Action/types';
import TaskAddForm from './containers/TaskAddForm';
import { TasksEditForm } from './containers/TaskEditForm';

export const TasksContainer: React.FC<
    {
        taskId?: string;
        serviceOrderId?: string;
    } & WithGuideLink
> = ({ guideLink, taskId, serviceOrderId }) => {
    const formId = useUUID();
    const scope = useCurrentEnterpriseId();
    const closeButton = useCloseButton();

    const actions: HeadingAction[] = [
        {
            url: guideLink,
            icon: IconName.Help,
            text: <LocalizedText textKey={TextKey.Help} />,
            target: '_blank',
            type: ActionType.Link,
        },
    ];

    const formName = `task-form-${formId}`;

    return (
        <ModalWrapper>
            <ModalHeader
                primaryAction={closeButton}
                title={<LocalizedText textKey={TextKey.Task} />}
                actions={actions}
            />
            <ModalBodyWrapper>
                <SmallContentContainer condensed>
                    <Card>
                        {taskId === undefined ? (
                            <TaskAddForm form={formName} serviceOrderId={serviceOrderId} scope={scope} />
                        ) : (
                            <TasksEditForm form={formName} taskId={taskId} scope={scope} />
                        )}
                    </Card>
                </SmallContentContainer>
            </ModalBodyWrapper>
        </ModalWrapper>
    );
};
